module.exports = __webpack_public_path__ + "media/什么是遥感.4ec20cae.mp4";